class WImobilequickadd extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
      document.addEventListener('quickAddPopOpen', (event) => {  
        let productHandle = event.detail;
        this.renderProductinfo(productHandle);
      });
      this.addEventListener('click', async (event) => {
        let cBlock = event.target.closest('.WI_mobileQiuckAddRender_color_con');
        let closeBtn = event.target.closest('.WI_mobileQuickAdd_close');
        if (closeBtn) {
            let mobileQuickAddPopMain = document.querySelector('.WI_mobileQuickAdd_main');
            let mobileQuickAddPopIn = document.querySelector('.WI_mobileQuickAdd_in');
            mobileQuickAddPopMain.style.backgroundColor = 'rgba(0, 0, 0, 0)';
            mobileQuickAddPopIn.style.opacity = '0';
            mobileQuickAddPopIn.style.visability = 'hidden';
            mobileQuickAddPopIn.style.transform = 'translateY(100%)';
            setTimeout(() => {
                mobileQuickAddPopMain.style.display = 'none';
            },210);
        }
      });
    }

     // render the product info
     async renderProductinfo(productData) {
        console.log(productData);
        try {
            let res = await fetch(`/products/${productData}?view=mobilequickadd`);
            let data = await res.text();
            let html_div = document.createElement('div');
            html_div.innerHTML = data;
            console.log(html_div);
            document.querySelector('.WI_mobileQuickAdd_in').innerHTML = html_div.innerHTML; 
            let mobileQuickAddPopMain = document.querySelector('.WI_mobileQuickAdd_main');
        let mobileQuickAddPopIn = document.querySelector('.WI_mobileQuickAdd_in');
        mobileQuickAddPopMain.style.display = 'flex';
        setTimeout(() => {
            mobileQuickAddPopMain.style.backgroundColor = 'rgba(0, 0, 0, 0.4)';
            mobileQuickAddPopIn.style.opacity = '1';
            mobileQuickAddPopIn.style.visability = 'visible';
            mobileQuickAddPopIn.style.transform = 'translateY(0)';
            let reRenderSplide = this.querySelector('.WI_mobileQiuckAddRenderSplide');
            var splide = new Splide( reRenderSplide, {
                type: 'slide',
                perPage: 2,
                perMove: 1,
            }).mount();
            document.dispatchEvent(new CustomEvent('quickAddRendered', {bubbles: true}));
        }, 10);
            

            
        } catch (error) {
            console.log(error);     
        }
    }
}
customElements.define('wi-mobilequickadd', WImobilequickadd);

class WImobilequickaddrender extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', async (event) => {
            let cBlock = event.target.closest('.WI_mobileQiuckAddRender_color_con');
            let mobileAddBtn = event.target.closest('.WI_productCardElement_variant_mobileBtnBtn');
            if (cBlock) {
                let siblings = Array.from(cBlock.parentNode.children).filter(child => child !== cBlock);
            console.log(siblings);
            siblings.forEach(el => el.classList.remove('WI_color_active'));
            cBlock.classList.add('WI_color_active');
                let productHandle = cBlock.getAttribute('data-producthandle');
                console.log(productHandle);
                
                this.renderProductCard(productHandle);
            }
        });
        document.addEventListener('quickAddRendered', (event) => {
           this.selectingVariant();
           this.fetchProductData();
        });
    }

    // Selecting variant
    selectingVariant() {
        this.addEventListener('click', async (event) => {
            let varaintInputCon = event.target.closest('input[type="radio"]');
            if (varaintInputCon) {
                let variantInput = this.querySelectorAll('input[type="radio"]');
                let varArray = [];
                setTimeout(() => {
                    variantInput.forEach(inp => {
                        if (inp.checked) {
                            varArray.push(inp.value);
                            console.log(varArray);
                            
                        }
                    });
    
                    if (varArray.length > 0) {
                        this.updateProductOptions(varArray);
                    }
                }, 10);
            }
        });
     }

     // Update the Product options
        updateProductOptions(varArray) {
            let varJSON = this.querySelector('script[type="application/json"]');
            if (varJSON) {
                let variantData = JSON.parse(varJSON.textContent);
                for (let i = 0; i < variantData.length; i++) {
                    if (JSON.stringify(variantData[i].options) == JSON.stringify(varArray)) {
                        console.log(variantData[i].id);
                        this.updateProductVariant(variantData[i].id);
                        this.fetchProductData(variantData[i].id);
                        break;
                    }
                }
                
            }
        }

        // Updating product variant
        async updateProductVariant(variantid) {
            this.querySelector('.WI_mobileQiuckAddRender_atcbtn').disabled = true;
            try {
                let productData = this.getAttribute('data-producthandle');
                let res = await fetch(`/products/${productData}?view=mobilequickadd&variant=${variantid}`);
                let data = await res.text();
                let html_div = document.createElement('div');
                html_div.innerHTML = data;
                let productCardVariant = html_div.querySelector('wi-mobilequickaddrender .WI_mobileQuickAddVariants_main');
                this.querySelector('.WI_mobileQuickAddVariants_main').innerHTML = productCardVariant.innerHTML;
                this.querySelector('.WI_mobileQiuckAddRender_atcbtn').disabled = false;
            } catch (error) {
                console.log(error);
            }
        }

      // Fetching product data
      fetchProductData(variantid) { 
        let addToCartBtn = this.querySelector('.WI_mobileQiuckAddRender_atcbtn');
        if (!addToCartBtn) return; // Prevent errors if button is not found
    
        // Remove existing event listeners
        addToCartBtn.replaceWith(addToCartBtn.cloneNode(true));
        addToCartBtn = this.querySelector('.WI_mobileQiuckAddRender_atcbtn'); // Re-select button after cloning
    
        // Add a single event listener
        addToCartBtn.addEventListener('click', async () => {
            if (variantid == undefined) {
                variantid = addToCartBtn.getAttribute('data-varId');
            }
            addToCartBtn.querySelector('svg').style.display = 'flex';
            try {
                let formData = {
                    'items': [{
                        'id': variantid,
                        'quantity': 1
                    }]
                };
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });
                document.dispatchEvent(new CustomEvent('wi:add', {bubbles: true}));
                document.dispatchEvent(new CustomEvent('theme:cartchanged', {bubbles: true}));
                addToCartBtn.querySelector('svg').style.display = 'none';
            } catch (error) {
                console.log(error);
            }
        });
    }

     // Rendering product card when clicking on color 
     async renderProductCard(productData) {
        try {
            let res = await fetch(`/products/${productData}?view=mobilequickadd`);
            let data = await res.text();
            let html_div = document.createElement('div');
            html_div.innerHTML = data;
            console.log(html_div);


            let productCardImgList = html_div.querySelector('wi-mobilequickaddrender .WI_mobileQiuckAddRender_image');
            let productCardTitle = html_div.querySelector('wi-mobilequickaddrender .WI_mobileQiuckAddRender_info h2');
            let productCardPrice = html_div.querySelector('wi-mobilequickaddrender .WI_mobileQiuckAddRender_price');
            let productCardVariant = html_div.querySelector('wi-mobilequickaddrender .WI_mobileQuickAddVariants_main');
            let productHandle = html_div.querySelector('wi-mobilequickaddrender').getAttribute('data-producthandle');
            let productAtcBtnSingleVarId = html_div.querySelector('wi-mobilequickaddrender .WI_mobileQiuckAddRender_atc');

            // Replace only the clicked product card
            const setInner = (sel, source) => {
                const target = this.querySelector(sel);
                if (target && source) target.innerHTML = source.innerHTML;
            };
            setInner('.WI_mobileQiuckAddRender_image', productCardImgList);
            setInner('.WI_mobileQiuckAddRender_info h2', productCardTitle);
            setInner('.WI_mobileQiuckAddRender_price', productCardPrice);
            setInner('.WI_mobileQuickAddVariants_main', productCardVariant);
            if (productHandle) this.setAttribute('data-producthandle', productHandle);
            setInner('.WI_mobileQiuckAddRender_atc', productAtcBtnSingleVarId);
            
            let reRenderSplide = this.querySelector('.WI_mobileQiuckAddRenderSplide');
            var splide = new Splide( reRenderSplide, {
                type: 'slide',
                perPage: 2,
                perMove: 1,
            }).mount();
            this.selectingVariant();
            this.fetchProductData();

        } catch (error) {
            console.log(error);
        }
    }
}
customElements.define('wi-mobilequickaddrender', WImobilequickaddrender);